import { useState, useEffect, useCallback } from "react";
import { getSupabase } from "@/lib/supabase";
import type { HackerProfile } from "@/hooks/useHackers";

export function useClaimedListings(userId: string | undefined) {
  const [listings, setListings] = useState<HackerProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchListings = useCallback(async () => {
    if (!userId) {
      setListings([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const supabase = getSupabase();
      const { data, error: supaError } = await supabase
        .from("hacker_listings")
        .select("*")
        .eq("profile_id", userId)
        .order("created_at", { ascending: false });

      if (supaError) throw supaError;
      setListings((data || []) as HackerProfile[]);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load your listings");
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchListings();
  }, [fetchListings]);

  return { listings, loading, error, refetch: fetchListings };
}